import { getDatabase, ref, get } from "firebase/database";
import limitsConfig from "../../config/limitsConfig";

/**
 * Lấy tổng số giờ đăng bài của tất cả thiết lập ACTIVE của user
 * @param {string} userId - ID của người dùng
 * @param {string} excludeConfigId - ID của thiết lập cần loại trừ (nếu đang edit)
 * @returns {Promise<Object>} - Thông tin về giờ đăng bài
 */
export const getTotalActivePostingHours = async (userId, excludeConfigId = null) => {
  try {
    if (!userId) {
      return {
        totalHours: 0,
        maxHours: limitsConfig.MAX_AUTO_POST_HOURS,
        remaining: limitsConfig.MAX_AUTO_POST_HOURS,
      };
    }

    const db = getDatabase();
    const configsRef = ref(db, `/posts/${userId}/`);
    const snapshot = await get(configsRef);

    let totalHours = 0;
    if (snapshot.exists()) {
      snapshot.forEach((childSnapshot) => {
        const config = childSnapshot.val();
        const configId = childSnapshot.key;

        // Loại trừ config đang edit
        if (excludeConfigId && configId === excludeConfigId) {
          return;
        }

        // Chỉ tính các thiết lập đang active
        if (config.autoPostEnabled) {
          const times = config.times || [];
          totalHours += times.length;
        }
      });
    }

    const maxHours = limitsConfig.MAX_AUTO_POST_HOURS;
    const remaining = Math.max(0, maxHours - totalHours);

    return {
      totalHours,
      maxHours,
      remaining,
    };
  } catch (error) {
    console.error("Error getting total active posting hours:", error);
    return {
      totalHours: 0,
      maxHours: limitsConfig.MAX_AUTO_POST_HOURS,
      remaining: limitsConfig.MAX_AUTO_POST_HOURS,
      error: error.message,
    };
  }
};

/**
 * Kiểm tra xem có thể thêm giờ đăng bài mới không
 * @param {string} userId - ID của người dùng
 * @param {string} configId - ID của thiết lập hiện tại
 * @param {Array} newTimes - Danh sách giờ mới
 * @param {boolean} isActive - Có active thiết lập này không
 * @returns {Promise<Object>} - Kết quả kiểm tra
 */
export const canAddPostingHours = async (userId, configId, newTimes, isActive) => {
  try {
    // Nếu không active, luôn cho phép
    if (!isActive) {
      const info = await getTotalActivePostingHours(userId, configId);
      return {
        canAdd: true,
        ...info,
        exceeded: false,
      };
    }

    // Nếu active, kiểm tra giới hạn
    const info = await getTotalActivePostingHours(userId, configId);
    const newTimesCount = newTimes ? newTimes.length : 0;
    const totalAfterAdd = info.totalHours + newTimesCount;
    const maxHours = limitsConfig.MAX_AUTO_POST_HOURS;

    return {
      canAdd: totalAfterAdd <= maxHours,
      totalHours: info.totalHours,
      maxHours,
      remaining: info.remaining,
      exceeded: totalAfterAdd > maxHours,
      newTimesCount,
      totalAfterAdd,
    };
  } catch (error) {
    console.error("Error checking if can add posting hours:", error);
    return {
      canAdd: false,
      error: error.message,
      totalHours: 0,
      maxHours: limitsConfig.MAX_AUTO_POST_HOURS,
      remaining: limitsConfig.MAX_AUTO_POST_HOURS,
    };
  }
};

